import React, { useEffect, useState } from "react";
import SidebarContant from "./sidebarcontent/SidebarContant";
import AccordionItem from "../accordian/AccordianItem";
import { useSelector } from "react-redux";
import { FILE_ICON } from "../../assets/images/index";

//All Modals

import SaleProgram from "../../pages/allModals/saleprogram/SaleProgram";
import Invoice from "../../pages/allModals/invoice/Invoice";
import CreateAuctionCenterModal from "../../pages/createAuctionCenter/CreateAuctionCenterModal";
import CreateStateMasterModal from "../../pages/createStateMaster/CreateStateMasterModal";
import CreateSptfModal from "../../pages/CreateSptf/createSptfModel";
import Awr from "../../pages/allModals/awr/AWR";
import KutchCatalog from "../../pages/allModals/kutchacatalog/KutchaCatalog";
import LotNoSeries from "../../pages/allModals/lotnoseries/LotNoSeries";
import SampleShortage from "../../pages/allModals/sampleshortage/SampleShortage";
import AuctionSession from "../../pages/allModals/auctionSesson/AuctionSession";
import AuctionCatalog from "../../pages/allModals/auctioncatalog/AuctionCatalog";
import CreateCategoryModal from "../../pages/createCategory/CreateCategoryModal";
import CreateTeaTypeModal from "../../pages/createTeaType/CreateTeaTypeModal";
import CreateSubTeaTypeModal from "../../pages/createSubTeaType/CreateSubTeaTypeModal";
import CreatePlantationDistrictMasterModal from "../../pages/createPlantationDistrictMaster/CreatePlantationDistrictMasterModal";
import CreateRevenueDistrictMasterModal from "../../pages/createRevenueDistrictMaster/CreateRevenueDistrictMasterModal";
import CreateGradeModal from "../../pages/createGrade/CreateGradeModal";
import CreateFactoryTypeModal from "../../pages/createFactoryType/CreateFactoryTypeModal";
import CreateRoleModal from "../../pages/createRole/CreateRoleModal";
import ChargeCodeModal from "../../pages/chargeCode/chargeCodeModal";
import CreateBankAccountDetailModal from "../../pages/createBankAccountDetail/createBankAccountDetailModal";
import CreateTaxMasterModal from "../../pages/createTaxMaster/createTaxMasterModal";
import CreateSpuMasterDetailModal from "../../pages/createSpuMaster/createSpuMasterModal";
import CreateConfigureParameterModal from "../../pages/CreateConfigureParameter/CreateConfigureParameterModal";
import AuctioneerUserRegistrationModal from "../../pages/RegisterUser/RegisterUserModal";
import WarehouseUserRegistrationModal from "../../pages/RegisterUser/RegisterUserModal";
import RegisterUser from "../../pages/RegisterUser/RegisterUser";
import RegisterUserModal from "../../pages/RegisterUser/RegisterUserModal";
import WarehouseUserRegistration from "../../pages/RegisterUser/WarehouseUserRegistration/WarehouseUserRegistration";
import GroupMaster from "../../pages/allModals/groupMaster/GroupMaster";
import CreateChargeMasterModal from "../../pages/createChargeMaster/CreateChargeMasterModal";
import MaxBidEntry from "../../pages/allModals/maxBidEntry/MaxBidEntry";
import BusinessRule from "../../pages/allModals/businessRule/BusinessRule";
import PreAuctionStatusReport from "../../pages/allModals/preAuctionStatusReport/PreAuctionStatusReport";
import TeaQualityReport from "../../pages/allModals/teaQualityReport/TeaQualityReport";
// import UserRegistrationModel from "../../pages/UserRegistration/UserRegistrationModel";
// import ToaUserRegistrationModel from "../../pages/createToaUserRegistration/CreateToaUserRegistrationModel";
// import CreateRegistration from "../../pages/createRegistration/CreateRegistration";
import PrsAuctionCatalogBuyer from "../../pages/allModals/prsAuctionCatalogBuyer/PrsAuctionCatalogBuyer";
// import PrsAuctionCatalog from "../../pages/allModals/PRSAuctioncatalog/PrsAuctionCatalog";
import { Accordion } from "@mui/material";
// import PrsAuctionCatalog from "../../pages/allModals/prsAuctioncatalog/PrsAuctionCatalog";
import PrsAuctionCatalog from "../../pages/allModals/prsAuctionCatalog/PrsAuctionCatalog";
import SaleProgramBuyerSallerReport from "../../pages/allModals/saleProgramBuyerSaller/SaleProgramBuyerSallerReport";

// import BuyerRegistration from "../../pages/BuyerRegistration/BuyerRegistration";
import CreateMarkModel from "../../pages/createMark/CreateMarkModel";
import CreatepackageSizeModal from "../../pages/CreatePackageSize/CreatepackageSizeModal";
import CreatepackageTypeModal from "../../pages/CreatePackageType/CreatepackageTypeModal";
import { useDispatch } from "react-redux";
// import viewDealBookModal from "../../pages/PostAuction/viewDealBook/viewDealBookModal";
import AuctionSessionBuyerSallerReport from "../../pages/allModals/auctionSessionBuyerSeller/AuctionSessionBuyerSallerReport";
import ViewDealBookModal from "../../pages/PostAuction/viewDealBook/viewDealBookModal";
import InvoiceListModal from "../../pages/invoiceList/invoiceListModal";
import AllocateFundBuyerModel from "../../pages/PostAuction/allocateFund/AllocateFundBuyerModel";
import RedemptionRequestModel from "../../pages/PostAuction/Refund/RedemptionRequestModel";
import SellerTaxInvoice from "../../pages/SellerTaxInvoice/SellerTaxInvoiceModel";
import ViewBuyerTaxInvoice from "../../pages/viewBuyerTaxInvoice/viewBuyerTaxInvoiceModal";
import GenerateSellerTaxInvoiceModal from "../../pages/generateSellerTaxInvoice/generateSellerTaxInvoiceModal";
import ReportTest1 from "../../pages/Reports/test1/ReportTest1";
import ReportTest2 from "../../pages/Reports/test2/ReportTest2";
import ReportTest3 from "../../pages/Reports/test3/ReportTest3";
import ReportTest4 from "../../pages/Reports/test4/ReportTest4";
import ReportTest5 from "../../pages/Reports/test5/ReportTest5";
import ReportTest6 from "../../pages/Reports/test6/ReportTest6";
import ReportTest7 from "../../pages/Reports/test7/ReportTest7";
import ReportTest8 from "../../pages/Reports/test8/ReportTest8";
import ReportTest9 from "../../pages/Reports/test9/ReportTest9";
import ReportTest10 from "../../pages/Reports/test10/ReportTest10";
import ReportTest11 from "../../pages/Reports/test11/ReportTest11";
import ReportTest12 from "../../pages/Reports/test12/ReportTest12";
import ReportTest13 from "../../pages/Reports/test13/ReportTest13";
import ReportTest14 from "../../pages/Reports/test14/ReportTest14";
import ReportTest15 from "../../pages/Reports/test15/ReportTest15";
import ReportTest16 from "../../pages/Reports/test16/ReportTest16";
import ReportTest17 from "../../pages/Reports/test17/ReportTest17";
import ReportTest18 from "../../pages/Reports/test18/ReportTest18";
import ReportTest19 from "../../pages/Reports/test19/ReportTest19";
import ReportTest20 from "../../pages/Reports/test20/ReportTest20";
import ReportTest21 from "../../pages/Reports/test21/ReportTest21";
import ReportTest22 from "../../pages/Reports/test22/ReportTest22";
import ReportTest23 from "../../pages/Reports/test23/ReportTest23";
import ReportTest24 from "../../pages/Reports/test24/ReportTest24";
import ReportTest25 from "../../pages/Reports/test25/ReportTest25";
import ReportTest26 from "../../pages/Reports/test26/ReportTest26";
import ReportTest27 from "../../pages/Reports/test27/ReportTest27";
import ReportTest28 from "../../pages/Reports/test28/ReportTest28";
import ReportTest29 from "../../pages/Reports/test29/ReportTest29";
import ReportTest30 from "../../pages/Reports/test30/ReportTest30";
import ReportTest31 from "../../pages/Reports/test31/ReportTest31";
import ReportTest32 from "../../pages/Reports/test32/ReportTest32";
import ReportTest33 from "../../pages/Reports/test33/ReportTest33";
import ReportTest34 from "../../pages/Reports/test34/ReportTest34";
import ReportTest35 from "../../pages/Reports/test35/ReportTest35";
import ReportTest36 from "../../pages/Reports/test36/ReportTest36";
import ReportTest37 from "../../pages/Reports/test37/ReportTest37";
import ReportTest38 from "../../pages/Reports/test38/ReportTest38";
import ReportTest39 from "../../pages/Reports/test39/ReportTest39";
import ReportTest40 from "../../pages/Reports/test40/ReportTest40";
import ReportTest41 from "../../pages/Reports/test41/ReportTest41";
import ReportTest42 from "../../pages/Reports/test42/ReportTest42";
import ReportTest43 from "../../pages/Reports/test43/ReportTest43";
import ReportTest44 from "../../pages/Reports/test44/ReportTest44";
import ReportTest45 from "../../pages/Reports/test45/ReportTest45";
import ReportTest46 from "../../pages/Reports/test46/ReportTest46";
import ReportTest47 from "../../pages/Reports/test47/ReportTest47";
import ReportTest48 from "../../pages/Reports/test48/ReportTest48";
import ReportTest49 from "../../pages/Reports/test49/ReportTest49";
import ReportTest50 from "../../pages/Reports/test50/ReportTest50";
import ReportTest51 from "../../pages/Reports/test51/ReportTest51";
import ReportTest52 from "../../pages/Reports/test52/ReportTest52";
import ReportTest53 from "../../pages/Reports/test53/ReportTest53";
import ReportTest54 from "../../pages/Reports/test54/ReportTest54";
import ReportTest55 from "../../pages/Reports/test55/ReportTest55";
import ReportTest56 from "../../pages/Reports/test56/ReportTest56";
import ReportTest57 from "../../pages/Reports/test57/ReportTest57";
import ReportTest58 from "../../pages/Reports/test58/ReportTest58";
import ReportTest59 from "../../pages/Reports/test59/ReportTest59";
import ReportTest60 from "../../pages/Reports/test60/ReportTest60";
import CreateGraceModal from "../../pages/CreateGrace/CreateGraceModal";
import TaxInvoice from "../../pages/BuyerTaxInvoice/BuyerTaxInvoiceModel";
import IndividualTaxInvoice from "../../pages/IndividualTaxInvoice/IndividualTaxInvoiceModel";
import {
  fetchUserRightsRequest,
  getBankRedirectUrl,
} from "../../store/actions";
import TransferDealBookModal from "../../pages/PostAuction/transferDealBook/transferDealBookModal";
import DeliveryInstructionAdviceModal from "../../pages/PostAuction/deliveryInstructionAdvice/deliveryInstructionAdviceModal";
import AuctionSearchBidBookModal from "../../pages/auctionSearchBidBook/AuctionSearchBidBookModal";
import RuleEngineEng from "../../pages/ruleEngineEng/RuleEngineEngModel";
import ChangePwd from "../../pages/ChangePwd/ChangePwdModel";

import AddWarehouseBillUploadsModal from "../../pages/PostAuction/addWarehouseBillUploads/addWarehouseBillUploadsModal";
import ManageRolesModal from "../../pages/manageRoles/ManageRolesModal";
import { useAuctionDetail } from "../common/AunctioneerDeteailProvider";
import RejectWarehouseBillModal from "../../pages/PostAuction/rejectWarehouseBill/rejectWarehouseBillModal";
import Profileupdatelink from "../../pages/profileupdatelink/profileupdatelink";
import ContactLinkModel from "../../pages/ContactUs/ContactModel";
import SupportLinkModel from "../../pages/SuppurtLink/SupportModel";
import BankDetailUpdate from "../../pages/bankDetailUpdate/bankUpdateDetailModal";
import BankReportsUserRoleWise from "../../pages/Reports/BankReportsUserRoleWise";
import ViewBidBookModal from "../../pages/viewBidBook/viewBidBookModal";
import ViewNotificationModal from "../../pages/viewNotification/viewNotificationModel";
import SellerCharges from "../../pages/allModals/SellerCharges/SellerCharges";
import ReportTest66 from "../../pages/Reports/test66/ReportTest66";
import ReportTest65 from "../../pages/Reports/test65/ReportTest65";
import ReportTest64 from "../../pages/Reports/test64/ReportTest64";
import ReportTest63 from "../../pages/Reports/test63/ReportTest63";
import ReportTest62 from "../../pages/Reports/test62/ReportTest62";
import ReportTest61 from "../../pages/Reports/test61/ReportTest61";
import ReportTest67 from "../../pages/Reports/test67/ReportTest67";
import ReportTest68 from "../../pages/Reports/test68/ReportTest68";
import ReportTest69 from "../../pages/Reports/test69/ReportTest69";
import ReportTest70 from "../../pages/Reports/test70/ReportTest70";
import ReportTest71 from "../../pages/Reports/test71/ReportTest71";
import ReportTest72 from "../../pages/Reports/test72/ReportTest72";
import ReportTest73 from "../../pages/Reports/test73/ReportTest73";
import ReportTest74 from "../../pages/Reports/test74/ReportTest74";
import ReportTest75 from "../../pages/Reports/test75/ReportTest75";
import ReportTest76 from "../../pages/Reports/test76/ReportTest76";
import ReportTest77 from "../../pages/Reports/test77/ReportTest77";
import ReportTest78 from "../../pages/Reports/test78/ReportTest78";
import ReportTest79 from "../../pages/Reports/test79/ReportTest79";
import ReportTest80 from "../../pages/Reports/test80/ReportTest80";
import ReportTest81 from "../../pages/Reports/test81/ReportTest81";
import ReportTest82 from "../../pages/Reports/test82/ReportTest82";
import ReportTest83 from "../../pages/Reports/test83/ReportTest83";
import ReportTest84 from "../../pages/Reports/test84/ReportTest84";
import ReportTest85 from "../../pages/Reports/test85/ReportTest85";
import ReportTest86 from "../../pages/Reports/test86/ReportTest86";
import ReportTest87 from "../../pages/Reports/test87/ReportTest87";
import ReportTest88 from "../../pages/Reports/test88/ReportTest88";
import ReportTest89 from "../../pages/Reports/test89/ReportTest89";
import ReportTest90 from "../../pages/Reports/test90/ReportTest90";
import ReportTest91 from "../../pages/Reports/test91/ReportTest91";
import ReportTest92 from "../../pages/Reports/test92/ReportTest92";
import ReportTest93 from "../../pages/Reports/test93/ReportTest93";
import ReportTest94 from "../../pages/Reports/test94/ReportTest94";
import ReportTest95 from "../../pages/Reports/test95/ReportTest95";
import ReportTest96 from "../../pages/Reports/test96/ReportTest96";
import ReportTest97 from "../../pages/Reports/test97/ReportTest97";
import ReportTest98 from "../../pages/Reports/test98/ReportTest98";
import ReportTest99 from "../../pages/Reports/test99/ReportTest99";
import ReportTest100 from "../../pages/Reports/test100/ReportTest100";
import ReportTest101 from "../../pages/Reports/test101/ReportTest101";
import ReportTest102 from "../../pages/Reports/test102/ReportTest102";
import ReportTest103 from "../../pages/Reports/test103/ReportTest103";
import ReportTest104 from "../../pages/Reports/test104/ReportTest104";
import ReportTest105 from "../../pages/Reports/test105/ReportTest105";
import ReportTest106 from "../../pages/Reports/test106/ReportTest106";
import ReportTest107 from "../../pages/Reports/test107/ReportTest107";
import ReportTest108 from "../../pages/Reports/test108/ReportTest108";
import BidHistoryReportEAuction from "../../pages/BidHistoryEAUction/bidHistoryEAuctionModal";
import ReportTest110 from "../../pages/Reports/test110/ReportTest110";
import ReportTest109 from "../../pages/Reports/test109/ReportTest109";
import ReportTest111 from "../../pages/Reports/test111/ReportTest111";
import ReportTest112 from "../../pages/Reports/test112/ReportTest112";
import ReportTest115 from "../../pages/Reports/test115/ReportTest115";
import ReportTest117 from "../../pages/Reports/test117/ReportTest117";
import ReportTest118 from "../../pages/Reports/test118/ReportTest118";
import ReportTest119 from "../../pages/Reports/test119/ReportTest119";
import ReportTest120 from "../../pages/Reports/test120/ReportTest120";
import ReportTest121 from "../../pages/Reports/test121/ReportTest121";
import ReportTest122 from "../../pages/Reports/test122/ReportTest122";

import TcsDetails from "../../pages/Reports/NewReports/TcsDetails";
import TcsInvoices from "../../pages/Reports/NewReports/TcsInvoices";
import TdsInvoicesAuctioner from "../../pages/Reports/NewReports/TdsInvoicesAuctioner";
import TdsInvoicesSeller from "../../pages/Reports/NewReports/TdsInvoicesSeller";
import WarehouseUserServiceInvoice from "../../pages/Reports/NewReports/WarehouseUserServiceInvoice";
import CategoryWiseSoldQty from "../../pages/Reports/NewReports/CategoryWiseSoldQty";
import BuyerPaymentStatus from "../../pages/Reports/NewReports/BuyerPaymentStatus";

import AuctionBidHistoryReportModal from "../../pages/auctionBidHistoryReport/AuctionBidHistoryReportModal";
import TestLinkModel from "../../pages/TestLink/TestModel";
import LSPModal from "../../pages/allModals/lspModal/lspModal";
import CreateNotificationModal from "../../pages/notifications/createNotificationModal";
function Sidebar() {
  const [expandedTab, setExpandedTab] = useState("Master");
  const [modalNames, setModalNames] = useState("");
  const [modalRight, setModalRight] = useState([]);
  const [moduleLists, setMduleList] = useState([]);
  const [linkId, setLinkId] = useState(null);
  const userRole = atob(sessionStorage.getItem("argument6"));
  const activeClass = useSelector((state) => state.toggle.activeClass);
  const moduleList = useSelector(
    (state) => state?.ModuleReducer?.data?.responseData
  );

  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    auction,
    roleCode,
  } = useAuctionDetail();

  const userRoleCode = atob(localStorage.getItem("argument6"));
  const contant = SidebarContant?.filter((ele) => ele.show == true);

  const filteredSidebarData = SidebarContant.map((section) => {
    if (Array.isArray(section.content)) {
      section.content = section.content.filter(
        (item) => !item.roleCode || item.roleCode.includes(userRole)
      );
    }
    return section;
  });

  useEffect(() => {
    if (moduleList !== null && moduleList !== undefined) {
      //Static bid book code start
      if (
        userRoleCode == "TAOUSER" ||
        userRoleCode == "BUYER" ||
        userRoleCode == "ASSOCIATEBUYER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEBUYER" ||
        userRoleCode == "AUCTIONEER" ||
        userRoleCode == "ASSOCIATEAUCTIONEER" ||
        userRoleCode == "POSTAUCTIONASSOCIATEAUCTIONEER" ||
        userRoleCode == "WAREHOUSE" ||
        userRoleCode == "SELLER" ||
        userRoleCode == "TEABOARDUSER"
      ) {
        moduleList?.auctionCentersList
          ?.map((eles) => eles.modulesDtoList)[0]
          .map((link) => {
            if (link.moduleid == 3) {
              link.linksDtoList.push({ linkId: 10786 });
            }
          });
        moduleList?.auctionCentersList
          ?.map((eles) => eles.modulesDtoList)[0]
          .map((link) => {
            const has64Or63 = link.linksDtoList.some(
              (dto) => dto.linkId === 64 || dto.linkId === 63
            );

            if (has64Or63) {
              // If 64 or 63 is found, ensure there is an entry with linkId 0
              if (!link.linksDtoList.some((dto) => dto.linkId === 0)) {
                link.linksDtoList.push({ linkId: 0 });
              }
            } else {
              // If neither 64 nor 63 is found, remove the entry with linkId 0 if it exists
            }
          });
      }
      //Static VideBID Book code end
      moduleList?.auctionCentersList
        ?.map((eles) => eles.modulesDtoList)
        ?.at(0)
        .push({ moduleid: 99, linksDtoList: [{ linkId: 299, rightIds: [] }] });
      moduleList?.auctionCentersList
        ?.map((eles) => eles.modulesDtoList)
        ?.at(0)
        .push({ moduleid: 100, linksDtoList: [{ linkId: 300, rightIds: [] }] });

      moduleList?.auctionCentersList
        ?.map((eles) => eles.modulesDtoList)
        ?.at(0)
        .push({ moduleid: 101, linksDtoList: [{ linkId: 301, rightIds: [] }] });
      moduleList?.auctionCentersList
        ?.map((eles) => eles.modulesDtoList)
        ?.at(0)
        .push({ moduleid: 102, linksDtoList: [{ linkId: 302, rightIds: [] }] });
      moduleList?.auctionCentersList
        ?.map((eles) => eles.modulesDtoList)
        ?.at(0)
        .push({
          moduleid: 5,
          linksDtoList: [
            { linkId: 100, rightIds: [] },
            { linkId: 101, rightIds: [] },
            { linkId: 102, rightIds: [] },
            { linkId: 103, rightIds: [] },
            { linkId: 104, rightIds: [] },
            { linkId: 105, rightIds: [] },
            { linkId: 106, rightIds: [] },
            { linkId: 107, rightIds: [] },
            { linkId: 108, rightIds: [] },
            { linkId: 109, rightIds: [] },
            { linkId: 110, rightIds: [] },
            { linkId: 111, rightIds: [] },
            { linkId: 112, rightIds: [] },
            { linkId: 113, rightIds: [] },
            { linkId: 114, rightIds: [] },
            { linkId: 115, rightIds: [] },
            { linkId: 116, rightIds: [] },
            { linkId: 200, rightIds: [] },
            { linkId: 201, rightIds: [] },
            { linkId: 202, rightIds: [] },
            { linkId: 203, rightIds: [] },
            { linkId: 204, rightIds: [] },
            { linkId: 205, rightIds: [] },
            { linkId: 206, rightIds: [] },
            { linkId: 207, rightIds: [] },
            { linkId: 208, rightIds: [] },
            { linkId: 209, rightIds: [] },
            { linkId: 210, rightIds: [] },
            { linkId: 211, rightIds: [] },
            { linkId: 212, rightIds: [] },
            { linkId: 213, rightIds: [] },
            { linkId: 214, rightIds: [] },
            { linkId: 215, rightIds: [] },
            { linkId: 216, rightIds: [] },
            { linkId: 217, rightIds: [] },
            { linkId: 218, rightIds: [] },
            { linkId: 219, rightIds: [] },
            { linkId: 220, rightIds: [] },
            { linkId: 221, rightIds: [] },
            { linkId: 222, rightIds: [] },
            { linkId: 223, rightIds: [] },
            { linkId: 224, rightIds: [] },
            { linkId: 225, rightIds: [] },
            { linkId: 226, rightIds: [] },
            { linkId: 227, rightIds: [] },
            { linkId: 228, rightIds: [] },
            { linkId: 229, rightIds: [] },
            { linkId: 230, rightIds: [] },
            { linkId: 231, rightIds: [] },
            { linkId: 232, rightIds: [] },
            { linkId: 233, rightIds: [] },
            { linkId: 234, rightIds: [] },
            { linkId: 235, rightIds: [] },
            { linkId: 236, rightIds: [] },
            { linkId: 237, rightIds: [] },
            { linkId: 238, rightIds: [] },
            { linkId: 239, rightIds: [] },
            { linkId: 240, rightIds: [] },
            { linkId: 241, rightIds: [] },
            { linkId: 242, rightIds: [] },
            { linkId: 243, rightIds: [] },
            { linkId: 244, rightIds: [] },
            { linkId: 245, rightIds: [] },
            { linkId: 246, rightIds: [] },
            { linkId: 247, rightIds: [] },
            { linkId: 248, rightIds: [] },
            { linkId: 249, rightIds: [] },
            { linkId: 250, rightIds: [] },
            { linkId: 251, rightIds: [] },
            { linkId: 252, rightIds: [] },
            { linkId: 253, rightIds: [] },
            { linkId: 254, rightIds: [] },
            { linkId: 255, rightIds: [] },
            { linkId: 256, rightIds: [] },
            { linkId: 257, rightIds: [] },
            { linkId: 258, rightIds: [] },
            { linkId: 259, rightIds: [] },
            { linkId: 260, rightIds: [] },
            { linkId: 261, rightIds: [] },
            { linkId: 262, rightIds: [] },
            { linkId: 263, rightIds: [] },
            { linkId: 264, rightIds: [] },
            { linkId: 265, rightIds: [] },
            { linkId: 266, rightIds: [] },
            { linkId: 267, rightIds: [] },
            { linkId: 268, rightIds: [] },
            { linkId: 269, rightIds: [] },
            { linkId: 270, rightIds: [] },
            { linkId: 271, rightIds: [] },
            { linkId: 272, rightIds: [] },
            { linkId: 273, rightIds: [] },
            { linkId: 274, rightIds: [] },
            { linkId: 275, rightIds: [] },
            { linkId: 276, rightIds: [] },
            { linkId: 277, rightIds: [] },
            { linkId: 278, rightIds: [] },
            { linkId: 279, rightIds: [] },
            { linkId: 280, rightIds: [] },
            { linkId: 281, rightIds: [] },
            { linkId: 282, rightIds: [] },
            { linkId: 283, rightIds: [] },
            { linkId: 284, rightIds: [] },
            { linkId: 285, rightIds: [] },
            { linkId: 286, rightIds: [] },
            { linkId: 287, rightIds: [] },
            { linkId: 288, rightIds: [] },
            { linkId: 289, rightIds: [] },
            { linkId: 290, rightIds: [] },
            { linkId: 291, rightIds: [] },
            { linkId: 292, rightIds: [] },
            { linkId: 293, rightIds: [] },
            { linkId: 294, rightIds: [] },
            { linkId: 295, rightIds: [] },
            { linkId: 296, rightIds: [] },
            { linkId: 297, rightIds: [] },
            { linkId: 298, rightIds: [] },
            { linkId: 299, rightIds: [] },
            { linkId: 300, rightIds: [] },
            { linkId: 301, rightIds: [] },
            { linkId: 302, rightIds: [] },
            { linkId: 303, rightIds: [] },
            { linkId: 304, rightIds: [] },
            { linkId: 305, rightIds: [] },
            { linkId: 306, rightIds: [] },
            { linkId: 307, rightIds: [] },
            { linkId: 308, rightIds: [] },
            { linkId: 309, rightIds: [] },
            { linkId: 310, rightIds: [] },
            // ----------------------------------------------------
            { linkId: 500, rightIds: [] },
            { linkId: 501, rightIds: [] },
            { linkId: 502, rightIds: [] },
            { linkId: 503, rightIds: [] },
            { linkId: 504, rightIds: [] },
            { linkId: 505, rightIds: [] },
            { linkId: 506, rightIds: [] },
            //----------------------------------------------------

            { linkId: 311, rightIds: [] },
            { linkId: 312, rightIds: [] },
            { linkId: 313, rightIds: [] },
            { linkId: 314, rightIds: [] },
            { linkId: 315, rightIds: [] },
          ],
        });
      moduleList?.auctionCentersList
        ?.map((eles) => eles.modulesDtoList)
        ?.at(0)
        .push({
          moduleid: 6,
          linksDtoList: [{ linkId: 1, rightIds: [] }],
        });
      // eslint-disable-next-line react-hooks/exhaustive-deps
      console.log(
        moduleList?.auctionCentersList
          ?.map((eles) => eles.modulesDtoList)
          ?.at(0)
          .map(
            (ele) =>
              ele.linksDtoList
                ?.map(
                  (item) => item.linkId === 68 && item.rightIds === "1"
                  // &&
                  // ["1"].includes(item.rightIds)
                )
                .filter((ele) => ele !== false)
            // .includes(68) && ele.linksDtoList
          )
          .reduce((acc, cur) => acc.concat(cur), []).length >
          0 ===
          false &&
          moduleList?.auctionCentersList
            ?.map((eles) => eles.modulesDtoList)
            ?.at(0)
            .map(
              (ele) =>
                ele.linksDtoList
                  ?.map(
                    (item) => item.linkId === 68 && item.rightIds
                    // ["1"].includes(item.rightIds)
                  )
                  .filter((ele) => ele !== false)
              // .includes(68) && ele.linksDtoList
            )
            .reduce((acc, cur) => acc.concat(cur), []).length > 0,
        "moduleList?.auctionCentersList"
      );

      if (
        ["TAOUSER", "TEABOARDUSER"].includes(roleCode) &&
        moduleList?.auctionCentersList
          ?.map((eles) => eles.modulesDtoList)
          ?.at(0)
          .filter((ele) => ele.moduleid === 1).length === 0
      ) {
        moduleList?.auctionCentersList
          ?.map((eles) => eles.modulesDtoList)
          ?.at(0)
          .unshift({ moduleid: 1, linksDtoList: [] });
        setMduleList(moduleList);
      } else {
        setMduleList(moduleList);
      }
    } else {
      setMduleList([]);
    }
  }, [moduleList]);

  function findCommonModules(array1, array2) {
    return array1
      ?.map((obj1) => array2?.find((obj2) => obj2.moduleId === obj1.moduleid))
      ?.filter(Boolean);
  }
  function findCommonModulesList(array1, array2) {
    return array1
      ?.map((obj1) =>
        array2?.find(
          (obj2) =>
            obj2.moduleId === obj1.moduleid && obj2.linkId === obj1.linkId
        )
      )
      ?.filter(Boolean);
  }
  let data = moduleLists?.auctionCentersList
    ?.map((eles) => eles.modulesDtoList)
    ?.at(0)
    ?.map((ele) => ele.linksDtoList);

  // data?.push({ linkId: 100, rightIds: [] });
  //CHECK RESGISTER RIGHT AND LINKID.
  const checkRightAndLinkID =
    moduleList?.auctionCentersList
      ?.map((eles) => eles.modulesDtoList)
      ?.at(0)
      .map(
        (ele) =>
          ele.linksDtoList
            ?.map(
              (item) => item.linkId === 68 && item.rightIds === "1"
              // &&
              // ["1"].includes(item.rightIds)
            )
            .filter((ele) => ele !== false)
        // .includes(68) && ele.linksDtoList
      )
      .reduce((acc, cur) => acc.concat(cur), []).length >
      0 ===
      false &&
    moduleList?.auctionCentersList
      ?.map((eles) => eles.modulesDtoList)
      ?.at(0)
      .map(
        (ele) =>
          ele.linksDtoList
            ?.map(
              (item) => item.linkId === 68 && item.rightIds
              // ["1"].includes(item.rightIds)
            )
            .filter((ele) => ele !== false)
        // .includes(68) && ele.linksDtoList
      )
      .reduce((acc, cur) => acc.concat(cur), []).length > 0;

  const combinedArray =
    moduleLists?.auctionCentersList === null &&
    ["TAOUSER", "TEABOARDUSER"].includes(roleCode)
      ? [
          {
            show: true,
            modalName: "Utility",
            title: "Master",
            moduleId: 1,
            content: [
              {
                name: "manageRole",
                title: "Manage Roles",
                rightIds: [],
              },
            ],
          },
        ]
      : moduleLists?.auctionCentersList
        ?.map((eles) => eles.modulesDtoList)
        ?.at(0)
        .map((itemsList) => {
          let dataList = findCommonModules(
            moduleLists?.auctionCentersList
              ?.map((eles) => eles.modulesDtoList)
              ?.at(0),
            filteredSidebarData
          ).map((ele) =>
            ele.moduleId === itemsList.moduleid
              ? {
                ...ele,
                content: ele?.content
                  .map((itemListData, index) => {
                    return itemsList?.linksDtoList
                      ?.map((itemListss) =>
                        itemListss.linkId === itemListData.linkId
                          ? {
                            ...itemListData,
                            rightIds: itemListss.rightIds,
                          }
                          : ""
                      )
                      .filter((itemsListData) => itemsListData !== "");
                  })
                  .reduce((acc, cur) => acc.concat(cur), []),
              }
              : ""
          );

          return dataList;
        })
        ?.reduce((acc, cur) => acc.concat(cur), [])
        ?.filter((ele) => ele !== "")
        ?.map((ele) =>
          // ele.moduleId === 1 && ["TAOUSER", "TEABOARDUSER"].includes(roleCode)
          ele.moduleId === 1
            ? {
              ...ele,
              content: [
                ...ele.content,
                moduleList?.auctionCentersList
                  ?.map((eles) => eles.modulesDtoList)
                  ?.at(0)
                  .map((ele) =>
                    ele.linksDtoList?.map(
                      (item) => [69].includes(item.linkId)
                      // &&
                      // ["1"].includes(item.rightIds)
                    )
                  )
                  ?.filter((ele) => ele !== false)
                  ?.at(0)
                  ?.filter((ele) => ele)
                  ?.includes(true) && {
                  name: "manageRole",
                  title: "Manage Roles",
                  rightIds: moduleList?.auctionCentersList
                    ?.map((eles) => eles.modulesDtoList)
                    ?.at(0)
                    ?.map(
                      (ele) =>
                        ele.linksDtoList
                          // ?.map((item) =>
                          //   [28, 27, 26, 25, 24, 23, 22, 20, 19, 18, 17,21]
                          //     ?.map((eless) => {
                          //       return eless === item.linkId
                          //         ? ele.linksDtoList
                          //         : "";
                          //     })

                          //     ?.filter((ele) => ele !== "")
                          // )
                          // ?.at(0)
                          // ?.reduce((acc, curr) => acc?.concat(curr), [])
                          ?.filter(
                            (item) => [69]?.includes(item.linkId)
                            // ["1"].includes(item.rightIds)
                          )
                      // ?.filter(
                      //   (itm) =>
                      //     itm.linkId === 68 && itm.rightIds.includes("1")
                      // )
                    )
                    ?.reduce((acc, curr) => acc?.concat(curr), []),
                },
                moduleList?.auctionCentersList
                  ?.map((eles) => eles.modulesDtoList)
                  ?.at(0)
                  .map((ele) =>
                    ele.linksDtoList?.map(
                      (item) =>
                        [
                          68, 28, 27, 26, 25, 24, 23, 22, 20, 19, 18, 17,
                          21,
                        ].includes(item.linkId)
                      // &&
                      // ["1"].includes(item.rightIds)
                    )
                  )
                  ?.filter((ele) => ele !== false)
                  ?.at(0)
                  ?.filter((ele) => ele)
                  ?.includes(true) && checkRightAndLinkID
                  ? {
                    name: "registerUser",
                    title: "Register User",
                    rightIds: moduleList?.auctionCentersList
                      ?.map((eles) => eles.modulesDtoList)
                      ?.at(0)
                      ?.map(
                        (ele) =>
                          ele.linksDtoList
                            // ?.map((item) =>
                            //   [28, 27, 26, 25, 24, 23, 22, 20, 19, 18, 17,21]
                            //     ?.map((eless) => {
                            //       return eless === item.linkId
                            //         ? ele.linksDtoList
                            //         : "";
                            //     })

                            //     ?.filter((ele) => ele !== "")
                            // )
                            // ?.at(0)
                            // ?.reduce((acc, curr) => acc?.concat(curr), [])
                            ?.filter(
                              (item) =>
                                [
                                  68, 28, 27, 26, 25, 24, 23, 22, 20, 19,
                                  18, 17, 21,
                                ]?.includes(item.linkId)
                              // ["1"].includes(item.rightIds)
                            )
                        // ?.filter(
                        //   (itm) =>
                        //     itm.linkId === 68 && itm.rightIds.includes("1")
                        // )
                      )
                      ?.reduce((acc, curr) => acc?.concat(curr), []),
                  }
                  : false,
              ].filter(Boolean),
            }
            : ele
        );

  const handleAccordionItemClick = (value) => {
    if (value === expandedTab) setExpandedTab("");
    else {
      setExpandedTab(value);
    }

    // Optionally, you can call handleAccordionChange here if needed.
    // handleAccordionChange(value.title)(null, !expandedTab === value.title);
  };
  const contentExpand = combinedArray?.map((ele) => ele.title === expandedTab);
  //with manage role filter //

  // old code //
  // moduleLists?.auctionCentersList
  //   ?.map((eles) => eles.modulesDtoList)
  //   ?.at(0)
  //   .map((itemsList) => {
  //     let dataList = findCommonModules(
  //       moduleLists?.auctionCentersList
  //         ?.map((eles) => eles.modulesDtoList)
  //         ?.at(0),
  //       filteredSidebarData
  //     ).map((ele) =>
  //       ele.moduleId === itemsList.moduleid
  //         ? {
  //             ...ele,
  //             content: ele?.content
  //               .map((itemListData, index) => {
  //                 return itemsList?.linksDtoList
  //                   ?.map((itemListss) =>
  //                     itemListss.linkId === itemListData.linkId
  //                       ? {
  //                           ...itemListData,
  //                           rightIds: itemListss.rightIds,
  //                         }
  //                       : ""
  //                   )
  //                   .filter((itemsListData) => itemsListData !== "");
  //               })
  //               .reduce((acc, cur) => acc.concat(cur), []),
  //           }
  //         : ""
  //     );

  //     return dataList;
  //   })
  //   ?.reduce((acc, cur) => acc.concat(cur), [])
  //   ?.filter((ele) => ele !== "");

  // const dispatch = useDispatch();
  // const handleBankRedirectUrl = () => {
  //   console.log("Called done bank");
  //   dispatch({ userId: 1, walletUserCode: 23 });
  // };

  return (
    <div>
      <div className={activeClass ? "active SideBar" : "SideBar "}>
        <div className="SideBar-logo">
          <img src={FILE_ICON} className="img-fluid Logo" alt="Logo" />
          <h2 className="SideBar-title">eAuction</h2>
        </div>
        {/* Dynamic sidebar data */}

        {/* findCommonModules(
          moduleLists?.auctionCentersList
            ?.map((eles) => eles.modulesDtoList)
            ?.at(0),
          filteredSidebarData
        )
          ?.map((obj1) => {
            return {
              ...obj1,
              content: combinedArray?.filter((ele) => ele !== undefined),
            };
          }) */}
        {combinedArray
          ?.map((ele) =>
            ele.moduleId === 2 && auction === "ENGLISH"
              ? {
                  ...ele,
                  content: combinedArray
                    ?.filter((ele) => ele.moduleId === 2)
                    ?.at(0)
                    ?.content?.map((item) =>
                      item.linkId === 43
                        ? { ...item, title: "Offline Bid Entry" }
                        : item
                    ),
                }
              : ele
          )
          ?.map((value, index) => (
            <AccordionItem
              key={index}
              title={value.title}
              content={value.content}
              setModalNames={setModalNames}
              contentExpand={contentExpand}
              setModalRight={setModalRight}
              index={index}
              handleAccordionItemClick={handleAccordionItemClick}
              linkId={linkId}
              setLinkId={setLinkId}
            />
          ))}
        {/* Static sidebar data */}
        {/* {filteredSidebarData?.map((value, index) =>
          userRole === "TEABOARDUSER" ||
          (userRole === "TAOUSER" && value.content === "manageRole") ? (
            ""
          ) : (
            <AccordionItem
              key={index}
              title={value.title}
              content={value.content}
              setModalNames={setModalNames}
              contentExpand={contentExpand}
              index={index}
              handleAccordionItemClick={handleAccordionItemClick}
            />
          )
        )} */}
        {/* <button
          className="LogoutBtn"
          onClick={() => {
            handleBankRedirectUrl();
          }}
        >
          Bank Button
        </button> */}
      </div>
      <SaleProgram
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <LSPModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <Invoice
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateStateMasterModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateAuctionCenterModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateCategoryModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateTeaTypeModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateSubTeaTypeModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreatePlantationDistrictMasterModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateRevenueDistrictMasterModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateGradeModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateFactoryTypeModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateRoleModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateBankAccountDetailModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateTaxMasterModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateSpuMasterDetailModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <CreateNotificationModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      {/* <CreateRegistration modalRight={modalRight} open={modalNames} setOpen={setModalNames} /> */}
      {/* <UserRegistrationModel modalRight={modalRight} open={modalNames} setOpen={setModalNames} />
      <ToaUserRegistrationModel modalRight={modalRight} open={modalNames} setOpen={setModalNames} /> */}
      <Awr modalRight={modalRight} open={modalNames} setOpen={setModalNames} />
      <ChargeCodeModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <SampleShortage
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <KutchCatalog
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <AuctionSession
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <LotNoSeries
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <AuctionCatalog
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <GroupMaster
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateConfigureParameterModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <RegisterUserModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      {/* <WarehouseUserRegistration modalRight={modalRight} open={modalNames} setOpen={setModalNames} /> */}
      <CreateChargeMasterModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <MaxBidEntry
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <BusinessRule
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <PreAuctionStatusReport
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <TeaQualityReport
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <PrsAuctionCatalogBuyer
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <PrsAuctionCatalog
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <SaleProgramBuyerSallerReport
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateMarkModel
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreatepackageSizeModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreatepackageTypeModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ViewDealBookModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <AllocateFundBuyerModel
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <RedemptionRequestModel
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <InvoiceListModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ViewBuyerTaxInvoice
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <GenerateSellerTaxInvoiceModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <TaxInvoice
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <IndividualTaxInvoice
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <RuleEngineEng
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <AuctionSessionBuyerSallerReport
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <BankReportsUserRoleWise
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
        linkId={linkId}
      />
      <ReportTest1
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest2
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest3
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest4
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest5
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest6
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest7
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest8
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest9
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest10
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest11
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest12
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest13
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest14
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest15
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest16
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest17
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest18
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest19
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest20
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest21
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest22
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest23
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest24
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest25
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest26
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest27
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest28
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest29
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest30
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest31
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest32
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest33
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest34
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest35
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest36
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest37
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest38
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest39
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest40
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest41
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest42
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest43
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest44
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest45
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest46
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest47
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest48
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest49
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest50
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest51
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest52
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest53
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest54
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest55
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest56
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest57
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest58
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest59
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest60
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest61
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest62
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest63
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest64
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest65
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest66
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest67
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest68
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest69
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest70
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest71
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest72
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest73
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest74
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest75
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest76
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest77
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest78
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest79
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest80
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest81
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest82
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest83
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest84
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest85
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest86
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest87
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest88
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest89
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest90
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest91
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest92
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest93
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest94
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest95
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest96
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest97
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest98
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest99
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest100
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest101
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest102
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest103
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest104
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest105
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest106
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest107
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ReportTest108
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest109
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest110
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest111
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest112
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest115
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest117
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest118
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest119
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest120
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest121
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <ReportTest122
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <CreateGraceModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <SellerTaxInvoice
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <TransferDealBookModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <DeliveryInstructionAdviceModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <AuctionSearchBidBookModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ChangePwd
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <AddWarehouseBillUploadsModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ManageRolesModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <CreateSptfModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <RejectWarehouseBillModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <Profileupdatelink
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ContactLinkModel
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <SupportLinkModel
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      <BankDetailUpdate
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ViewBidBookModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <ViewNotificationModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <BidHistoryReportEAuction
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <SellerCharges
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />
      <AuctionBidHistoryReportModal
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
      />

      {/* ------------------------------------- */}

      <TcsDetails
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
        reportType="1"
      />

      <TcsInvoices
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
        reportType="2"
      />

      <TdsInvoicesAuctioner
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
        reportType="3"
      />

      <TdsInvoicesSeller
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
        reportType="4"
      />

      <WarehouseUserServiceInvoice
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
        reportType="5"
      />

      <CategoryWiseSoldQty
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
        reportType="6"
      />

      <BuyerPaymentStatus
        modalRight={modalRight}
        open={modalNames}
        setOpen={setModalNames}
        reportType="7"
      />
    </div>
  );
}

export default Sidebar;
